import { useState } from "react";
import {
  DEFAULT_APP_VAR,
  DEFAULT_LOCAL_STORAGE_KEY_FOR_APP_STATE,
} from "../constants";
import useLocalStorage from "./useLocalStorage";

const useApp = (isMaintenanceMode?: boolean): AppState => {
  const { getValue, setValue } = useLocalStorage<AppVars>();
  const [appState, setAppState] = useState<AppVars>(
    getValue(DEFAULT_LOCAL_STORAGE_KEY_FOR_APP_STATE) ?? DEFAULT_APP_VAR
  );

  const updateAppState = (appState: AppVars) => {
    setAppState(appState);
    setValue(DEFAULT_LOCAL_STORAGE_KEY_FOR_APP_STATE, appState);
  };

  return { appState, updateAppState, isMaintenanceMode };
};

export default useApp;
